import React, { Component } from "react";
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';
import BsyAlertMenu from "../BsyAlertMenu";
import BsyAlert from "../BsyAlert";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import { BsyUtils } from '../../utils/Utils';
import './index.css';
import BsyAlertTextEdit from "../BsyAlertTextEdit";
import BsyAlertQrcode from "../BsyAlertQrcode";
import { withRouter } from "react-router-dom";
import DocumentTitle from "react-document-title";
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import pubsub from 'pubsub-js'
import BsyDialog from "../BsyDialog";
import BsyCheckBox from "../BsyCheckBox";
import BsySelectAppPane from "../BsySelectAppPane";
import BsySlidePane from "../BsySlidePane";
import UpdateStandardAppPane from "./UpdateStandardAppPane";
import { UnbindApp } from "./unBindApp";
import { EditStandardApp } from "./EditStandardApp";
import { setPageTitle } from "../../utils/setPageTitle";

const DragHandle = sortableHandle(() => <i className="icon-bsy-iconyidong app-move" onClick={e => {
  e.stopPropagation();
}} />);

const SortableItem = sortableElement((props) => (
  <>{props.children}</>
));

const SortableContainer = sortableContainer(({ children }) => {
  return <div className={'group-box'}>{children}</div>;
});

class BsyAppPane extends Component {

  constructor(props) {
    super(props)
    this.state = {
      apps: [],
      dockItem: [],
      groupId: props.match && props.match.params && props.match.params.groupid ? props.match.params.groupid : '',
      hasUpdate: false,
      standardUpdateCont: {},
      isStandard: true
    }
    this.myapp = React.createRef();
    this.appView = React.createRef();
    this._fetchAppList();
  }

  selectApp = (appinfo) => {
    // console.log('selectApp', appinfo)
    this.props.history.push(`${window.rootDirectroy}/team/app/${appinfo._id}`)
    // if (this.props.onSelectApp) {
    //     this.props.onSelectApp(appinfo)
    // }
  }


  updateappsort = (group, apps) => {
    ///dashboard/app_group/updateappsort
    console.log(this)
    React.axios(this.state.isStandard ? '/dashboard/standardapp_group/updateappsort' : '/dashboard/app_group/updateappsort', {
      apps: apps,
      groupId: group
    }).then(res => {

    }).catch(res => {
      console.error(res);
    })
  }
  onSortEnd = (data, groupInfo) => {
    const { oldIndex, newIndex } = data;

    let csar = [];
    const scr = arrayMoveImmutable(groupInfo.apps, oldIndex, newIndex);
    scr.map((data, index) => {
      csar.push(data._id);
      return data;
    })
    let newapp = [...this.state.apps];
    newapp[groupInfo.index].apps = scr;
    this.setState({
      apps: newapp
    }, () => {
      this.updateappsort(groupInfo._id, csar);
    })

  };

  componentDidMount() {
    this._menuSort();
    this.appView.current.addEventListener('scroll', this.scrollFunc, false);
  }

  groupId = null;
  scrollTopVal = 0;
  scrollFunc = () => {
    let dTop = this.appView.current.scrollTop;
    let n = null;
    let hList = this.appView.current.getElementsByClassName("bsy-workspace-app_group");
    for (let i = 0; i < hList.length; i++) {
      let t = hList[i].offsetTop;
      // console.log(t,dTop,dTop+hList[i].clientHeight,t >= dTop && t <= dTop+hList[i].clientHeight)
      if (t >= dTop) {
        n = hList[i];
        i = hList.length
      }
    }

    if (n) {
      if (n.id !== this.groupId) {
        this.groupId = n.id;
        this.setState({
          groupId: n.id.split("appgroup_")[1]
        })
        this.props.history.push(window.rootDirectroy + (this.state.isStandard ? "/team/standard/group/" : "/team/group/") + n.id.split("appgroup_")[1]);
      }
      this.scrollTopVal = dTop;
    }
  }

  _appReName = (a, cl, d, cb) => {
    let _this = this;
    let FX = window.FX;

    BsyAlertTextEdit({
      title: React.language("msg.type.app_rename"),
      placeholder: React.language("enter.new.appName"),
      value: d,
      width: 350,
      onOk: (name) => {
        let result = {};
        if (!BsyUtils.checkValidateTitle(name || "", React.language("app.name"), result)) {
          return false;
        }

        FX.Utils.ajax({
          url: "/dashboard/app/" + a + "/update",
          data: {
            name: name,
          }
        }, function (d) {
          if (!FX.Utils.isObjectEmpty(d.app)) {
            _this.state.apps.map((res) => {
              res.apps.map((res1) => {
                if (res1._id === a) {
                  res1.appname = d.app.name
                }
                return res1;
              })
              return res;
            })
            cb && cb(d.app.name);
            _this.setState({
              apps: _this.state.apps
            }, () => {
              pubsub.publish('reAppMenu', {
                reName: d.app.name,
                appId: a
              })
            });
          }
          cl.parent().removeClass("select");
        })
      },
      onCancel: () => {
        cl.parent().removeClass("select");
      }
    })
  }


  _appEditStyle = (renderEl, data) => {
    let FX = window.FX;
    let $ = window.$;

    let colors = [3, 5, 1, 2, 0, 4];
    let icons = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];

    let curre_val = {
      color: data.style.color,
      icon: data.style.icon
    }

    let color = $('<ul class="menu-pane-color"/>');
    FX.Utils.forEach(colors, function (a1, b1) {
      color.append($('<span class="menu-item color-cover-' + b1 + ' "  />').attr("role", b1).addClass(data.style.color === b1 ? "selected" : ""));
    });

    let icon = $('<ul class="menu-pane-icon"/>');
    FX.Utils.forEach(icons, function (a1, b1) {
      icon.append($('<div class="menu-item color-cover-' + data.style.color + ' "  />').attr("role", b1).addClass(data.style.icon === b1 ? "selected" : "").append("<div class=' imgbg-bby-app imgbg-bby-app-" + b1 + "' >"));
    });
    let style_list = $('<div class="bby-workspace-app-style-pane"/>');
    style_list.append(color);
    style_list.append("<div class='menu-pane-split'>");
    style_list.append(icon);
    FX.Msg.bubble({
      anchor: renderEl,
      contentHTML: style_list,
      text4Cancel: null,
      text4Ok: null,
      workerMaxHeight: 565,
      minWidth: 130,
      dockPosition: "right",
      contentPadding: 0,
      edge: 350,
      onClose: function () {

        FX.Utils.ajax({
          url: "/dashboard/app/" + data._id + "/update",
          data: curre_val
        }, function (d) {
          if (d.code == 3007) {
            tipAlert({
              type: "warning",
              msg: React.language(d.msg) || React.language("error.201")
            })
          }
          pubsub.publish('reAppMenu', {
            reStyle: curre_val,
            appId: data._id
          })
        }, function (a, b) {
          let c = a.responseJSON || {};
          tipAlert({
            type: "error",
            msg: React.language(c.msg) || React.language("error.201")
          })
        }, function () {
        })
        renderEl.parent().removeClass("select");
        return !1;
      }
    });
    color.bind("click", function (f) {
      let g = $(f.target).closest(".menu-item");
      let h = g.attr("role");
      if (h !== undefined) {
        color.children(".menu-item").removeClass("selected");
        g.addClass("selected");
        icon.children(".menu-item").removeClass("color-cover-" + curre_val.color);
        const el = renderEl.parent().parent().find(".icon-backgroup")
        el.removeClass()
        curre_val.color = h;
        icon.children(".menu-item").addClass("color-cover-" + curre_val.color);
        el.addClass("icon-backgroup color-cover-" + curre_val.color);
      }
    })
    icon.bind("click", function (f) {
      let g = $(f.target).closest(".menu-item");
      let h = g.attr("role");
      if (h !== undefined) {
        icon.children(".menu-item").removeClass("selected");
        g.addClass("selected");

        let el = renderEl.parent().parent().find(".icon-backgroup div")
        el.removeClass();
        curre_val.icon = h;
        el.addClass("imgbg-bsy-app imgbg-bsy-app-" + curre_val.icon);
      }
    })
  }

  copyApp = (b, groupid, cb) => {
    let FX = window.FX;

    if (!b) {
      tipAlert({
        type: "warning",
        msg: React.language("select.app.group")
      })
      return;
    }
    let c = this;
    const { apps } = c.state
    let load = FX.Utils.createLoadLayer("body", {
      isLight: !0,
      hasLoader: !0
    })
    FX.Utils.ajax({
      url: "/dashboard/app/" + b._id + "/copy",
      data: {
        groupid: groupid
      }
    }, function (a) {
      let b = a.app;
      let appData = { parent: groupid };
      appData.appname = b.name;
      appData.copyable = b.copyable;
      appData.deletable = b.deletable;
      appData.editable = b.editable;
      appData.disable_export = b.disable_export;
      appData.editable = b.editable;
      appData.style = b.style;
      appData._id = b._id;

      BsyUtils.forEach(apps, (key, res) => {
        if (res._id === groupid) {
          res.apps.push(appData)
        }
      })
      c.setState({
        apps: apps
      }, () => {
        pubsub.publish('updateApps')
        pubsub.publish('updateAppMenu', { apps })
        tipAlert({
          type: "success",
          msg: React.language("app.copy.success")
        });
        cb && cb();
      })

    }, function (f, g) {
      let h = f.responseJSON || {}
        , e = h.msg || "";

      FX.Msg.alert({
        type: "error",
        title: React.language("copy.app"),
        msg: React.language("app.copy.fail") + e,
        onOk: function () {
          cb && cb();
        },
        onCancel: function () {
          cb && cb();
        },
      })
    }, function () {
      load && load.remove()
    })
  }

  _fetchAppList = (e) => {
    let t = this;
    let hasUpdate = false;
    this.appList ? e && e(this.appList) : React.axios(t.state.isStandard ? "/dashboard/standardapp_group/list" : "/dashboard/app_group/list").then(async (res) => {
      let i = res.data;
      i.items.map(res => {
        res.apps.map(res1 => {
          if (res1.appType === 4) {
            hasUpdate = true;
          }
          return null;
        })
        return null;
      })
      let standardUpdateCont = {};
      if (hasUpdate && (window.FX.STATIC.user_corps.isSysManager || window.FX.STATIC.user_corps.isCorpOwn)) {
        let res = await React.axios("/dashboard/standard_check_renew");
        standardUpdateCont = res.data;
      }
      t.setState({
        apps: i.items,
        dockItem: i.dock_items || [],
        standardUpdateCont: standardUpdateCont,
        hasUpdate: standardUpdateCont.hasRenew
      }, () => {
        const { groupId } = t.state;
        if (groupId) {
          if (document.getElementById("appgroup_" + groupId)) {
            t.appView.current.scrollTop = document.getElementById("appgroup_" + groupId).offsetTop - 62;
          } else {
            this.setState({
              groupId: ''
            }, () => {
              this.props.history.push(window.rootDirectroy + (t.state.isStandard ? "/team/standard/apps" : "/team/apps"))
              setTimeout(() => {
                this.appView.current.scrollTop = 0;
              })
            })
          }
        } else {
          t.appView.current.scrollTop = 0;
        }
      })
      e && e(i.items, standardUpdateCont)
    })
  }

  _getAppGroups = (t, renderEl) => {
    let FX = window.FX;
    let i = this
      , n = window.$('<div class="app-ref-copy-content">');
    this._fetchAppList(function (e) {
      let a = new FX.AppInstallGroup({
        renderEl: n,
        groups: e,
      });
      i.copyDialog = new FX.ConfirmDialog({
        title: React.language("template.copy.toGroup"),
        width: 450,
        height: 390,
        onContentCreate: function (e) {
          e.append(n)
        },
        onOk: function () {
          let toappid = a.getValue();
          i.copyApp(t, toappid.groupId, function () {

            i.copyDialog.close();
          });
          renderEl.parent().removeClass("select");
        }
      })
      i.copyDialog.show()
    })
  }

  _createQrcode = (e, renderEl) => {
    let FX = window.FX;
    let $ = window.$;
    let t = $(".url-icon-qrcode")
      , i = $('<div class="qrcode-dropdown"/>');
    $("<div id ='qrcode' style='border:solid 10px #fff;' />").appendTo(i);
    FX.Msg.bubble({
      anchor: t,
      dockPosition: "right",
      text4Ok: null,
      minWidth: 150,
      text4Cancel: null,
      contentHTML: i,
      scrollObj: $("#content"),
      hAdjust: 15
    });
    const pot = renderEl[0].getBoundingClientRect()
    const css = 160 > (document.documentElement.clientHeight - pot.top + renderEl[0].offsetHeight + 2) ? {
      left: pot.left + 'px',
      minWidth: renderEl[0].offsetWidth,
      bottom: document.documentElement.clientHeight - pot.top + 2 + 'px'
    } : {
      left: pot.left + 'px',
      minWidth: renderEl[0].offsetWidth,
      top: pot.top + renderEl[0].offsetHeight + 2 + 'px'
    }
    BsyAlertQrcode({
      value: encodeURI(e),  //value参数为生成二维码的链接
      size: 160, //二维码的宽高尺寸
      css: css,
      anchor: $("#qrcode")[0],
      text: React.language('msg.qrCode'),
      fgColor: "#000000"
    })
  }

  _shareAppInstall = (d, renderEl) => {
    let FX = window.FX;
    let $ = window.$;
    let e = this
      , t = d.shareInstall || []
      , i = {
        isInstall: t.isInstall || !1,
        installPwd: t.installPwd || null,
        installAccount: t.installAccount || null
      }
      , n = FX.CONFIG.HOST.SITE_HOST + (window.root_directroy ? window.root_directroy + '/' : '') + "data/ins/" + d._id
      , a = $('<div class="share-app-install"/>')
      ,
      s = $('<div class="pane-head"/>').append($("<span/>").text(React.language("installation.link"))).append($('<span class="subtitle"/>').text(React.language("installation.app.link"))).appendTo(a)
      , u = new FX.Switch({
        renderEl: $('<div class="head-line"/>').appendTo(s),
        value: i.isInstall,
        onSwitch: function (e) {
          e ? o.slideDown("fast") : o.slideUp("fast");
          let y = u.getValue()
            , t = h.getWidgetByName("passSwitch").getValue()
            , i = h.getWidgetByName("accountSwitch").getValue()
            , n = h.getWidgetByName("installPwd")
            , a = h.getWidgetByName("installAccount")
            , s = null
            , z = null
            , r = !0;
          if (t) {
            if (n.getValue() === "") {
              s = null
            } else {
              s = n.getValue()
            }
            n.checkValidate()
          }
          if (t && (s = n.getValue() === "" ? null : n.getValue(),
            n.checkValidate()), r)
            if (i && (z = a.getValue(),
              !FX.Utils.isEmpty(o)) || !i) {
              let l = null;
              FX.Utils.isEmpty(z) || (l = z.split(/[\n]+/));
              let c = {
                isInstall: y,
                installPwd: s,
                installAccount: l
              };
              d.shareInstall = c
              FX.Utils.dataAjax({
                url: "/data/ins/" + d._id + "/update",
                data: c
              }, function () {
                tipAlert({
                  type: "success",
                  msg: React.language("saveInfo.success")
                })
              }, function (e) {
                let t = e.responseJSON;
                t && tipAlert({
                  type: "error",
                  msg: t.msg || React.language("saveInfo.fail")
                })
              })
            } else
              a.showErrorMsg(React.language("account.no.empty"))
        }
      })
      , o = $('<div class="pane-body"/>').appendTo(a)
      , h = new FX.TableContainer({
        renderEl: $("<div/>").appendTo(o),
        rowSize: [1, 30, 30, 1, 30, 30, 1, 30, 80],
        colSize: [148, 40, 40, 40],
        hgap: 5,
        vgap: 10,
        padding: 10,
        items: [[{
          type: "separator",
          width: "100%"
        }], [{
          type: "label",
          text: React.language("app.installation.link"),
          baseCls: "x-label pane-label"
        }], [{
          type: "text",
          widgetName: "installUrl",
          enable: !1,
          width: 400,
          height: 30,
          text: n
        }, $('<a class="share-open x-btn style-white" title=React.language("openLink") target="_blank"/>').attr("href", n).text(React.language("open")), $('<a class="share-open x-btn style-white" title=React.language("link.copy")/>').text(React.language("copy")).on("click", function () {
          FX.Utils.copyToClipboard(n, function () {
            tipAlert({
              type: "success",
              msg: React.language("installation.copied.link.successfully")
            })
          })
        }), $("<i class='icon-qrcode url-icon-qrcode'/>").attr("title", React.language("generate.copied.link.successfully")).on("click", function () {
          e._createQrcode(n, $(this))
        })], [{
          type: "separator",
          width: "100%"
        }], [{
          type: "label",
          text: React.language("install.password"),
          baseCls: "x-label pane-label"
        }], [{
          type: "switch",
          width: 44,
          height: 22,
          widgetName: "passSwitch",
          value: !!i.installPwd,
          onSwitch: function (e) {
            let t = h.getWidgetByName("installPwd");
            if (e) {
              t.setVisible(!0)
              t.select()
            } else {
              t.setVisible(!1)
            }
            let i = h.getWidgetByName("accountSwitch")
              , n = h.getWidgetByName("installAccount");
            if (e) {
              i.setValue(!1)
              n.setVisible(!1)
            }
            let y = u.getValue()
              , k = h.getWidgetByName("passSwitch").getValue()
              , p = h.getWidgetByName("accountSwitch").getValue()
              , q = h.getWidgetByName("installPwd")
              , a = h.getWidgetByName("installAccount")
              , s = null
              , z = null
              , r = !0;
            if (k && (s = q.getValue(),
              q.checkValidate() || (r = !1)),
              r)
              if (p && (z = a.getValue(),
                !FX.Utils.isEmpty(o)) || !p) {
                let l = null;
                FX.Utils.isEmpty(z) || (l = z.split(/[\n]+/));
                let c = {
                  isInstall: y,
                  installPwd: s,
                  installAccount: l
                };
                d.shareInstall = c
                FX.Utils.dataAjax({
                  url: "/data/ins/" + d._id + "/update",
                  data: c
                }, function () {
                  tipAlert({
                    type: "success",
                    msg: React.language("saveInfo.success")
                  })
                }, function (e) {
                  let t = e.responseJSON;
                  t && tipAlert({
                    type: "error",
                    msg: t.msg || React.language("saveInfo.fail")
                  })
                })
              } else
                a.showErrorMsg(React.language("account.no.empty"))
          }
        }, {
          type: "text",
          widgetName: "installPwd",
          visible: !!i.installPwd,
          allowBlank: !1,
          waterMark: React.language("query.pass.type"),
          text: i.installPwd,
          width: 200,
          height: 30,
          regex: "^.{1,24}$",
          onStopEdit: function () {
            let y = u.getValue()
              , k = h.getWidgetByName("passSwitch").getValue()
              , p = h.getWidgetByName("accountSwitch").getValue()
              , q = h.getWidgetByName("installPwd")
              , a = h.getWidgetByName("installAccount")
              , s = null
              , z = null
              , r = !0;
            if (k && (s = q.getValue(),
              q.checkValidate() || (q.showErrorMsg(React.language("limit.password")),
                r = !1)),
              r)
              if (p && (z = a.getValue(),
                !FX.Utils.isEmpty(o)) || !p) {
                let l = null;
                FX.Utils.isEmpty(z) || (l = z.split(/[\n]+/));
                let c = {
                  isInstall: y,
                  installPwd: s,
                  installAccount: l
                };
                d.shareInstall = c;
                FX.Utils.dataAjax({
                  url: "/data/ins/" + d._id + "/update",
                  data: c
                }, function () {
                  tipAlert({
                    type: "success",
                    msg: React.language("saveInfo.success")
                  })
                }, function (e) {
                  let t = e.responseJSON;
                  t && tipAlert({
                    type: "error",
                    msg: t.msg || React.language("saveInfo.fail")
                  })
                })
              } else
                a.showErrorMsg(React.language("account.no.empty"))
          }
        }], [{
          type: "separator",
          width: "100%"
        }], [{
          type: "label",
          width: 170,
          text: React.language("accounts.allowed.install"),
          baseCls: "x-label pane-label"
        }], [{
          type: "switch",
          width: 44,
          height: 22,
          widgetName: "accountSwitch",
          value: !!i.installAccount,
          onSwitch: function (e) {
            let t = h.getWidgetByName("installAccount");
            if (e) {
              t.setVisible(!0)
              t.select()
            } else {
              t.setVisible(!1)
            }
            let i = h.getWidgetByName("passSwitch")
              , n = h.getWidgetByName("installPwd");
            if (e) {
              i.setValue(!1);
              n.setVisible(!1);
            }
            let y = u.getValue()
              , k = h.getWidgetByName("passSwitch").getValue()
              , p = h.getWidgetByName("accountSwitch").getValue()
              , q = h.getWidgetByName("installPwd")
              , a = h.getWidgetByName("installAccount")
              , s = null
              , z = null
              , r = !0;
            if (k && (s = q.getValue(),
              q.checkValidate() || (q.showErrorMsg(React.language("limit.password")),
                r = !1)),
              r)
              if (p && (z = a.getValue(),
                !FX.Utils.isEmpty(o)) || !p) {
                let l = null;
                FX.Utils.isEmpty(z) || (l = z.split(/[\n]+/));
                let c = {
                  isInstall: y,
                  installPwd: s,
                  installAccount: l
                };
                d.shareInstall = c;
                FX.Utils.dataAjax({
                  url: "/data/ins/" + d._id + "/update",
                  data: c
                }, function () {
                  tipAlert({
                    type: "success",
                    msg: React.language("saveInfo.success")
                  })
                }, function (e) {
                  let t = e.responseJSON;
                  t && tipAlert({
                    type: "error",
                    msg: t.msg || React.language("saveInfo.fail")
                  })
                })
              } else
                a.showErrorMsg(React.language("account.no.empty"))
          }
        }, {
          type: "textarea",
          visible: !!i.installAccount,
          widgetName: "installAccount",
          waterMark: React.language("enter.app.accounts"),
          width: 350,
          value: i.installAccount ? i.installAccount.join("\n") : "",
          onStopEdit: function () {
            let y = u.getValue()
              , k = h.getWidgetByName("passSwitch").getValue()
              , p = h.getWidgetByName("accountSwitch").getValue()
              , q = h.getWidgetByName("installPwd")
              , a = h.getWidgetByName("installAccount")
              , s = null
              , z = null
              , r = !0;
            if (k && (s = q.getValue(),
              q.checkValidate() || (q.showErrorMsg(React.language("limit.password")),
                r = !1)),
              r)
              if (p && (z = a.getValue(),
                !FX.Utils.isEmpty(o)) || !p) {
                let l = null;
                FX.Utils.isEmpty(z) || (l = z.split(/[\n]+/));
                let c = {
                  isInstall: y,
                  installPwd: s,
                  installAccount: l
                };
                d.shareInstall = c;
                FX.Utils.dataAjax({
                  url: "/data/ins/" + d._id + "/update",
                  data: c
                }, function () {
                  tipAlert({
                    type: "success",
                    msg: React.language("saveInfo.success")
                  })
                }, function (e) {
                  let t = e.responseJSON;
                  t && tipAlert({
                    type: "error",
                    msg: t.msg || React.language("saveInfo.fail")
                  })
                })
              } else
                a.showErrorMsg(React.language("account.no.empty"))
          }
        }]]
      })
      , r = ($('<span class="install-log"/>').text(React.language("view.installed.records")).on("click", function () {
        e._showInstallLog(d._id)
      }).appendTo($('<div class="pane-foot">').appendTo(a)),
        new FX.ConfirmDialog({
          customCls: "margintop",
          title: React.language("Share.app.install.others", { appname: d.appname }),
          width: 580,
          height: 580,
          onContentCreate: null,
          text4Ok: null,
          text4Cancel: null,
          contentWidget: {
            rowSize: [380],
            colSize: [560],
            padding: 10,
            items: [a]
          }
        }));
    i.isInstall ? o.show() : o.hide();
    r.show()
    renderEl.parent().removeClass("select")
  }

  removeApp = (appData, renderEl) => {
    let FX = window.FX;
    let $ = window.$;
    const _this = this;
    const { apps } = this.state

    function e(e) {
      s && s.okBtn && (e === appData.appname ? s.okBtn.setOnClick(!0) : s.okBtn.setOnClick(!1))
    }
    console.log(2222)
    let n = $('<div class="app-remove-confirm" style="marginTop: 20px;padding-left: 44px"/>')
      , a = $('<div class="app-input-name"/>').appendTo(n);

    new FX.TextEditor({
      renderEl: $('<div class="input-widget"/>').appendTo(a),
      waterMark: React.language("delete.app.name"),
      width: "100%",
      onAfterEdit: function () {
        e(this.getValue())
      },
      onStopEdit: function () {
        e(this.getValue())
      }
    });
    let s = FX.Msg.alert({
      title: React.language("want.delete.app", { appname: appData.appname }),
      msg: React.language("delete.form.irreversible"),
      content: n,
      type: "swarning",
      enable4Ok: !1,
      onOk: function () {

        let load = FX.Utils.createLoadLayer("body", {
          isLight: !0,
          hasLoader: !0
        })

        React.axios("/dashboard/app/" + appData._id + "/remove", {}).then(() => {
          BsyUtils.forEach(apps, (obj, res) => {

            // window.location.reload()
            // return ;

            renderEl.parent().removeClass("select");
            if (appData.parent === res._id) {
              BsyUtils.forEach(res.apps, (obj1, res1) => {
                if (appData._id === res1._id) {
                  apps[obj].apps.splice(obj1, 1)
                  _this.setState({
                    apps: apps
                  }, () => {
                    tipAlert({
                      type: "success",
                      msg: React.language("app.delete.success")
                    });
                    // load && load.remove();
                    // pubsub.publish('removeAppMenu', {
                    //     appData: appData,
                    //     type:"delApp"
                    // })
                    pubsub.publish('updateApps')
                    pubsub.publish('updateAppMenu', { apps })
                  })
                }
              })
            }
          })
          load && load.remove();
        }).catch(() => {
          load && load.remove();
          renderEl.parent().removeClass("select");
        })
      },
      onCancel: function () {
        renderEl.parent().removeClass("select");
      }
    })
    e();
  }

  downapp = (appinfo, renderEl) => {
    let FX = window.FX;
    let $ = window.$;


    let run = (hasData, disable_export) => {

      FX.Msg.notice({
        title: React.language("export.excel.notice.title"),
        type: "async",
        duration: 0,
        content: React.language("export.excel.notice.content")
      })

      React.axios("/dashboard/download_installapp", {
        _id: appinfo._id,
        sampledata: hasData ? true : false,
        disable_export: disable_export ? true : false,
      }).then(res => {

        if (res.data.code === 1) {
          let e = $("<div />").append($("<p />").text(React.language("export.excel.fileSuccess.content", {
            name: res.data.name,
            time: BsyUtils.convertToRemainingTime((window.siteDevInfo.sitesetting.export_datatable_max_time || 1440) * 60, 'hour'),
          })));
          e.append($("<a href='javascript:void(0);' />").text(React.language("download.immediately")).on("click", function () {
            BsyUtils.downloadFile2(res.data.name, res.data.url);
            return false;
          }))
          FX.Msg.notice({
            title: React.language("export.excel.fileSuccess"),
            type: "success",
            duration: 0,
            content: e
          })
        } else {

          FX.Msg.notice({
            title: React.language("export.failTip"),
            type: "error",
            duration: 0,
            content: res.data.msg
          })
        }

      }).catch(res => {

        console.error(res);
      })
    }
    let disable_export = false;
    let sampledata = false;

    BsyAlert({
      title: React.language("export.installation.package"),
      msg: <>
        <BsyCheckBox

          {...{
            text: React.language('app.batch.export.options.tip1'),
            value: disable_export
          }}
          onStopEdit={(e) => {
            disable_export = e;
          }}

        />
        <BsyCheckBox

          {...{
            text: React.language('export.installation.package.tip'),
            value: sampledata
          }}
          onStopEdit={(e) => {
            sampledata = e;
          }}

        />
      </>,
      type: "query",
      text4Ok: React.language("ok"),
      OkType: "blue",
      text4Cancel: React.language("cancel"),
      closeBtn: true,
      ok: () => {
        run(sampledata, disable_export)
      },
      // cancel: () => {
      //     run(false)
      // }
    })

    // FX.Utils.dataAjax({
    //     url: "/dashboard/download_installapp",
    //     data: retdata
    // }, function (b) {
    //     if (b.code === 1) {
    //         let e = "<p>" + React.language("export.excel.fileSuccess.content", { name: b.name, time: FX.STATIC.sitesetting.export_datatable_max_time / 60, }) + '</p><div style="text-align:right"><a href="' + b.url + '" target="_blank">' + React.language("download.immediately") + '</a></div>';
    //         FX.Msg.notice({
    //             title: React.language("export.excel.fileSuccess"),
    //             type: "success",
    //             duration: 0,
    //             content: $(e)
    //         })
    //     }
    //     else {

    //         FX.Msg.notice({
    //             title: React.language("export.failTip"),
    //             type: "error",
    //             duration: 0,
    //             content: b.msg
    //         })
    //     }
    // }, function (e) {
    //     let t = e.responseJSON;
    //     t && FX.Msg.notice({
    //         title: React.language("export.failTip"),
    //         type: "error",
    //         duration: 0,
    //         content: t.msg
    //     })
    // })
    renderEl.parent().removeClass("select")
  }

  _appMove = (appData, renderEl) => {
    let FX = window.FX;

    let i = this
      , n = window.$('<div class="app-ref-copy-content">');
    this._fetchAppList(function (e) {
      let a = new FX.AppInstallGroup({
        renderEl: n,
        groups: e,
      });
      i.moveDialog = new FX.ConfirmDialog({
        title: React.language("move.app.toGroup"),
        width: 450,
        height: 390,
        onContentCreate: function (e) {
          e.append(n)
        },
        onOk: function () {
          let toappid = a.getValue();
          let h = toappid.groupId
          FX.Utils.ajax({
            url: i.state.isStandard ? "/dashboard/standardapp_group/appmove" : "/dashboard/app_group/appmove",
            data: {
              source: appData.parent,
              appId: appData._id,
              to: h
            }
          }, function (d) {
            if (d.code === 0) {

            } else {
              tipAlert({
                type: "warning",
                msg: React.language(d.msg) || React.language("app.edit.group.fail1")
              })
            }
            i._fetchAppList();
            i.moveDialog.close();
          }, function (a, b) {
            let c = a.responseJSON || {};
            tipAlert({
              type: "error",
              msg: React.language(c.msg) || React.language("app.edit.group.fail3")
            })
            i._fetchAppList();
            i.moveDialog.close();
          }, function () {
            renderEl.closest(".bby-msg-bubble").remove()
            i.comboGroupList = null;
            i._fetchAppList();
            i.moveDialog.close();
          })
          renderEl.parent().removeClass("select");
        },
        onCancel: function () {
          renderEl.parent().removeClass("select");
          i.moveDialog.close()
        }
      })
      renderEl.parent().removeClass("select");
      i.moveDialog.show()
    })
  }

  eventCustMent = (h, appData, renderEl) => {
    console.log(88, h)
    renderEl.parent().addClass("select");
    let d = this;
    if (h) {
      switch (h) {
        case "rename": {
          d._appReName(appData._id, renderEl, appData.appname, function (appname) {
            appData.appname = appname;
            renderEl.data(appData);
          });
          break;
        }

        case "editstyle": {
          d._appEditStyle(renderEl, appData);
          break;
        }

        case "move": {
          d._appMove(appData, renderEl);
          break;
        }

        case "copy": {
          // FX.Msg.alert({
          //     title: React.language("app.copy"),
          //     msg: "确认复制应用？",
          //     type: "query",
          //     onOk: function () {
          //         d.copyApp()
          //     }
          // });
          // d.copyApp()
          d._getAppGroups(appData, renderEl);
          break;
        }

        case "share": {
          d._shareAppInstall(appData, renderEl)
          break;
        }

        case "delete": {
          d.removeApp(appData, renderEl)
          break;
        }

        // case "clear":
        // {
        //     d.cleanApp(appData)
        // }
        //     break;
        case 'downapp':
          d.downapp(appData, renderEl)
          break;
        case 'updateapp':
          d.updateapp(appData, renderEl)
          break;
        case 'unbind':
          d.unbind(appData, renderEl)
          break;
        case "debug": {
          d.debug(appData, renderEl)
          break;
        }
        default: {
          break;
        }
      }
    }
  }

  updateapp = (appData, renderEl) => {
    BsyDialog({
      title: React.language('unbind'),
      height: 340,
      width: 440,
      noFooter: false,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onOk: () => {

        renderEl.parent().removeClass("select")
      },
      onCancel: () => {
        renderEl.parent().removeClass("select")
      },
      onContentCreate: () => {
        this.packageContent = null;
        return <div className="packageUpdate">
          <div className="update-title">
            <span>{React.language('installation.package.update.title')}</span>
          </div>
          <div className="update-btn">
            <label className='contImg x-btn' htmlFor='file'><i
              className="icon-bsy-file"></i><span>{React.language('Upload.installation.package')}</span></label>
            <input type="file" id="file" name="file" className="upload-btn-input" accept=".bby,.bsy"
              style={{ display: "none" }} onChange={(e) => {
                this.updatePackage(e, appData._id)
              }} />
          </div>
          <div className="updateFile"></div>
        </div>;
      }
    })
  }

  unbind = (appData, renderEl) => {
    BsyDialog({
      title: React.language('unbind'),
      height: 360,
      width: 440,
      noFooter: true,
      onContentCreate: (ref) => {
        const tRef = ref;
        return <UnbindApp
          app={appData}
          onClose={() => {
            tRef.closeAlter();
          }}
        />;
      }
    })
  }


  debug = (appData, renderEl) => {
    BsyDialog({
      title: React.language('project.debug'),
      height: 260,
      width: 440,
      noFooter: true,
      onContentCreate: (ref) => {
        const tRef = ref;
        return <EditStandardApp
          app={appData}
          onClose={() => {
            tRef.closeAlter();
          }}
        />;
      }
    })
  }

  packageContent = null;

  updatePackage = (e, id) => {
    let files = e.target.files;
    let reader = new FileReader();
    const _this = this;
    reader.onload = function (evt) {
      let base64url = evt.target.result; //转换为base64地址形式
      let f = {
        file: BsyUtils.dataURLtoBlob(base64url),
        fileName: files[0].name
      };
      let formData = new FormData();
      formData.append("file", f.file, f.fileName);
      formData.append("appId", id);
      console.log(formData.has("file"), formData.get("file"));
      _this.packageContent = formData;
    }
    reader.readAsDataURL(files[0]);
    e.target.parentElement.childNodes[0].childNodes[1].textContent = React.language('installation.package.update.re');
    e.target.parentElement.parentElement.childNodes[2].textContent = files[0].name;
  }


  moreMenu = (data, index, event) => {
    // console.log(data, index, event)
    let $ = window.$;
    let menu = [];
    if (window.FX.STATIC.user_corps.isSysManager || window.FX.STATIC.user_corps.isCorpOwn) {
      if (data.editable) {
        menu.push({
          text: React.language('app.style.edit'),
          colorType: "",
          icon: "icon-bsy-iconyangshi",
          click: () => {
            this.eventCustMent('editstyle', data, $(event.target));
          }
        })
        menu.push({
          text: React.language('name.update'),
          colorType: "",
          icon: "icon-bsy-iconxiugai",
          click: () => {
            this.eventCustMent('rename', data, $(event.target));
          }
        })
      }
      if ((data.appType !== 4 && data.appType !== 3) && data.copyable) {
        menu.push({
          text: React.language('app.copy'),
          colorType: "",
          icon: "icon-bsy-iconfuzhi",
          click: () => {
            this.eventCustMent('copy', data, $(event.target));
          }
        })
      }
      if (data.editable) {
        menu.push({
          text: React.language('clean.data'),
          colorType: "",
          icon: "icon-bsy-iconqingli",
          click: () => {

            BsyAlert({
              title: React.language("clear.data.app", {
                appname: data.appname,
              }),
              msg: React.language('clear.data.irreversible'),
              type: "error-input",
              onInputValidate: (val) => {
                return val === data.appname
              },
              text4Ok: React.language("delete"),
              OkType: "red",
              placeholder: React.language("clear.app.name"),
              text4Cancel: React.language("cancel"),
              ok: (value) => {

                if (data.appname !== value) {

                  tipAlert({
                    type: "warning",
                    msg: React.language('empty.report.tip8')
                  })
                  return !1
                }

                React.axios('/dashboard/app/' + data._id + '/clean', {
                  groupId: data._id
                }).then(res => {
                  tipAlert({
                    type: "success",
                    msg: React.language('app.data.cleared')
                  })

                }).catch(res => {
                  console.error(res);
                })
                return true;
              }
            })
          }
        })
      }

      menu.push({
        text: React.language('moveTo.other.group'),
        colorType: "",
        icon: "icon-bsy-help-13",
        line: data.deletable || data.editable,
        click: () => {
          this.eventCustMent('move', data, $(event.target));
        }
      })

      if (data.deletable) {
        menu.push({
          text: React.language('app.delete'),
          icon: "icon-bsy-iconshanchu",
          colorType: "red",
          click: () => {
            this.eventCustMent('delete', data, $(event.target));
          }
        })
      }
      if (data.editable) {

        if (!data.disable_export) {
          data.appType !== 3 && menu.push({
            text: React.language('share.others.install'),
            colorType: "",
            icon: "icon-bsy-iconfenxianggei",
            // line: true,
            click: () => {
              this.eventCustMent('share', data, $(event.target));
            }
          })
          // menu.push({
          //   text: React.language('export.installation.package'),
          //   icon: "icon-export",
          //   colorType: "",
          //   click: () => {
          //     this.eventCustMent('downapp', data, $(event.target));
          //   }
          // })
          // menu.push({
          //   text: React.language('installation.package.update'),
          //   icon: "icon-bsy-reportmenu-15",
          //   colorType: "",
          //   click: () => {
          //     this.eventCustMent('updateapp', data, $(event.target));
          //   }
          // })
        }

      }

      if (data.appType === 4 && (BsyUtils.isSysManager() || BsyUtils.isCorpOwn())) {
        menu.push({
          text: React.language('unbind'),
          colorType: "",
          icon: "icon-bsy-standard-unbind",
          line: true,
          click: () => {
            this.eventCustMent('unbind', data, $(event.target));
          }
        })
        menu.push({
          text: React.language('project.debug'),
          colorType: "",
          icon: "icon-bsy-standard-debug",
          click: () => {
            this.eventCustMent('debug', data, $(event.target));
          }
        })
      }

    } else if (window.FX.STATIC.user_corps.isSubAdmin) {
      if (data.editable) {
        menu.push({
          text: React.language('app.style.edit'),
          colorType: "",
          icon: "icon-bsy-iconyangshi",
          click: () => {
            this.eventCustMent('editstyle', data, $(event.target));
          }
        })
        menu.push({
          text: React.language('name.update'),
          colorType: "",
          icon: "icon-bsy-iconxiugai",
          click: () => {
            this.eventCustMent('rename', data, $(event.target));
          }
        })
      }
      menu.push({
        text: React.language('moveTo.other.group'),
        colorType: "",
        icon: "icon-bsy-help-13",
        click: () => {
          this.eventCustMent('move', data, $(event.target));
        }
      })
    }

    const e = event.currentTarget;
    e.parentNode.classList.add("select");
    BsyUtils.closestClass(e, "bsy-workspace-appCont").style.overflow = "hidden";
    BsyAlertMenu({
      item: menu,
      width: 220,
      height: "auto",
      target: event.target,
      onClose: () => {
        BsyUtils.closestClass(e, "bsy-workspace-appCont").style.overflow = "auto";
        e.parentNode.classList.remove("select")
      }
    })

    event.stopPropagation();
  }

  renderApp = (item, noGroupOp) => {
    const { standardUpdateCont } = this.state;
    return (
      <>
        <div className='group-name'>
          <span className='name'>{item.name}</span>
          {!noGroupOp && <div className="groupItem">
            {item._id !== "default" && <span className="rename" onClick={(e) => {
              this.reGroupName(item)
            }}>{React.language("rename")}</span>}
            {item._id !== "default" && <span className="remove" onClick={(e) => {
              this.removeGroup(item)
            }}>{React.language("remove")}</span>}
          </div>}
        </div>

        <SortableContainer
          axis={'xy'}
          distance={10}
          useDragHandle={true}
          onSortEnd={e => {
            this.onSortEnd(e, item)
          }}>

          {
            item.apps.length === 0 ? <div className="empty">{React.language('appGroup.no.has')}</div> :
              item.apps.map((data, index) => {
                const hasAuth = window.FX.STATIC.user_corps.isSysManager || data.editable || data.deletable || data.copyable;
                const appNewList = BsyUtils.Store.get("appNewList") || [];
                BsyUtils.Store.set("appNewList", appNewList);
                return <SortableItem key={`item-${index}`} index={index} value={data}>
                  <div className={`group-box-item ${(data.appType === 3 || data.appType === 4) ? 'standard' : ''} ${appNewList.indexOf(data._id) > -1 ? 'new' : ''}`} id={data._id} onClick={this.selectApp.bind(this, data, index)}>
                    {
                      appNewList.indexOf(data._id) < 0 && standardUpdateCont && standardUpdateCont.appIds && standardUpdateCont.appIds.indexOf(data._id) > -1 &&
                      <div className="updateTip">
                        <i className="icon-bsy-import-export"></i>
                      </div>
                    }
                    {
                      appNewList.indexOf(data._id) > -1 &&
                      <div className="newTip">
                        <span>{React.language("new.export.app")}</span>
                      </div>
                    }
                    <div className="view">
                      <div className="app-wrapper">
                        <div className="icon-wrapper">
                          <div className={"icon-backgroup color-cover-" + data.style.color}>
                            <div className={"imgbg-bsy-app imgbg-bsy-app-" + data.style.icon}>
                            </div>
                          </div>
                        </div>
                        <div className="app-title" title={data.appname} id={"app_title_" + data._id}>
                          {data.appname}
                        </div>
                      </div>
                    </div>
                    {
                      (hasAuth && !data.dock) && <div className="op">
                        <i className="icon-bsy-iconshezhi app-info"
                          style={{ right: (window.FX.STATIC.user_corps.isSysManager ? "36px" : "16px") }} onClick={
                            this.moreMenu.bind(this, data, index)
                          } />
                        {window.FX.STATIC.user_corps.isSysManager && <DragHandle />}
                      </div>
                    }
                  </div>
                </SortableItem>
              })
          }
        </SortableContainer>

      </>
    )
  }

  selectAppGroupId = (id) => {
    return (e) => {
      e.currentTarget.parentNode.getElementsByClassName("select")[0].classList.remove("select");
      e.currentTarget.classList.add("select");
      this.standardAppGroupId = id;
    }
  }

  standardAppGroupId = ""
  selectAppContext = {};

  getSelectAppContext = (t) => {
    this.selectAppContext = t;
  }

  convertStandardApp = () => {
    BsyDialog({
      title: React.language("create.new.standard1"),
      width: 520,
      height: 524,
      noFooter: false,
      cancelText: React.language("cancel"),
      okText: React.language("nextStep"),
      onContentCreate: () => {
        return <BsySelectAppPane getContext={this.getSelectAppContext} />
      },
      onOk: () => {
        if (!this.selectAppContext.selectStandardAppId) {
          tipAlert({
            type: "warning",
            msg: React.language("select.application")
          })
          return false;
        }
        this.selectAppGroup(true)
      }
    })
  }

  selectAppGroup = (t, cd) => {
    BsyDialog({
      title: React.language("template.install.toGroup"),
      width: 460,
      height: 487,
      noFooter: false,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: () => {
        const { apps } = this.state;
        return <div className="selectAppGroupPane">
          <div className="selectAppGroup-title">{React.language("template.install.target.group")}</div>
          <div className="selectAppGroup-content">
            {
              apps.map((res, key) => {
                if (key === 0) {
                  this.standardAppGroupId = res._id;
                }
                return <div className={`appItems ${key === 0 ? "select" : ""}`} key={res._id}
                  onClick={this.selectAppGroupId(res._id)}>
                  <span
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    title={res.name}
                  >{res.name}</span>
                  <i className="icon-bsy-check3"></i>
                </div>
              })
            }
          </div>
        </div>
      },
      onOk: () => {
        let load = window.FX.Utils.createLoadLayer("body", {
          isLight: !0,
          hasLoader: !0
        })
        if (cd) {
          cd(this.standardAppGroupId);
          load && load.remove();
          return;
        }
        React.axios(t ? `/dashboard/app/${this.selectAppContext.selectStandardAppId}/copy_standard` : "/bbymember/tpl_install", {
          mode: "standard",
          groupid: this.standardAppGroupId
        }).then(res => {
          load && load.remove();
          this._fetchAppList();
        }).catch(res => {
          load && load.remove();
        })
      }
    })
  }

  openAddStandardPane = (e) => {
    let menu = [{
      text: React.language('create.new.standard'),
      iconColor: "#4ACC8C",
      click: (event) => {
        this.selectAppGroup();
      }
    }, {
      text: React.language('create.new.standard1'),
      iconColor: "var(--bsy-base-color)",
      click: () => {
        this.convertStandardApp();
      }
    }]
    BsyAlertMenu({
      item: menu,
      width: 240,
      customCls: "import-export-item",
      target: e.currentTarget,
    })
  }

  openUpdateStandardAppPane = () => {
    BsySlidePane({
      title: React.language("update.app"),
      hasHeader: true,
      onContentCreate: (ref) => {
        return <UpdateStandardAppPane slideRef={ref} apps={this.state.apps} loadAppList={this._fetchAppList}
          standardUpdateData={this.state.standardUpdateCont} />
      },
      onClose: () => {
        if (window.hasUpdateApp) {
          window.location.reload();
        }
        return true;
      }
    })
  }

  openImportExportPane = (e) => {
    let menu = [{
      text: React.language('batch.export.app'),
      icon: "icon-bsy-reportmenu-7",
      iconColor: "#333333",
      click: (event) => {
        this.openExportAppPane();
      }
    }, {
      text: React.language('batch.import.app'),
      icon: "icon-bsy-reportmenu-8",
      iconColor: "#333333",
      click: () => {
        this.openImportAppPane()
      }
    }]
    BsyAlertMenu({
      item: menu,
      width: 200,
      target: null,
      customCls: "import-export-item",
      position: {
        left: BsyUtils.elemoffset(e.currentTarget).left,
        top: BsyUtils.elemoffset(e.currentTarget).top + 15,
      }
    })
  }

  openImportAppPane = () => {
    const $ = window.$;
    const FX = window.FX;
    let i = this;
    let uploadel = $('<div class="app-upload-content" style="position: absolute;left: 20px;right: 20px;margin-left: 0;">');
    let uploadobj = new FX.ImportBby({
      renderEl: uploadel,
      maxLimitTip: React.language("installation.package.size.exceeds"),
      maxFileSize: 1024 * 1024 * 50,
      accept: ".bsys, .bsy",
      subtitle: '(.bsys和.bsy后缀的文件)',
      onChange: function (e) {
        copyDialog.element.find(".ImportBbyName").text(React.language("selected.it", { name: e[0].name }))
      }
    });
    let sampledata = false;
    let copyDialog = new FX.ConfirmDialog({
      title: React.language("app.batch.import"),
      subTitle: React.language("app.batch.import.subtitle"),
      width: 460,
      height: 264,
      style4Header: "center",
      onContentCreate: function (e) {
        let content = $('<div style="position: absolute;top: 20px;bottom: 62px;left: 0;right: 0;padding:0 20px; border-bottom: solid 1px #f2f2f2;" />')
        content.append(uploadel);
        content.append($("<div class='split-title' />").css({
          marginTop: '58px',
          width: '60px',
          height: '20px',
          fontSize: '14px',
          fontWeight: 'bold',
          color: '#333333',
          lineHeight: '20px',
        }).text(React.language('app.batch.import.set')));
        new FX.CheckBox({
          renderEl: $('<div class="split-title-set" />').css({
            marginTop: '12px',
          }).appendTo(content),
          text: React.language("import.package.group.tip"),
          onStateChange: function () {
            sampledata = this.getValue();
          }
        })
        content.appendTo(e);
      },
      onOk: function () {

        let file = uploadobj.getValue();
        if (file === '') {
          tipAlert({
            type: "warning",
            msg: React.language("select.file")
          })
        } else {
          file.append('sampledata', sampledata)


          copyDialog.close();
          copyDialog = null;
          let f = file.get("file");
          if (f.name.indexOf(".bsys") > -1) {
            FX.Msg.notice({
              title: React.language("app.batch.import.tip"),
              type: "async",
              duration: 0,
              content: React.language("member.async.start.tip")
            })

            $('.btn-status').text(React.language("app.batch.import.tip"));
            FX.Utils.ajaxUpload({
              url: '/dashboard/importbby_batch',
              data: file
            }, function (d) {
              FX.Msg.notice({
                title: d.msg || d.info,
                type: "success",
                duration: 0,
              })
              i._fetchAppList();
            }, null, function (d) {

              if (copyDialog) {
                copyDialog.close();
                copyDialog = null;
              }
              d.responseJSON && FX.Msg.notice({
                title: d.responseJSON.msg,
                type: "error",
                duration: 0,
              })
            });
          } else if (f.name.indexOf(".bsy") > -1) {
            i.selectAppGroup(false, (id) => {
              FX.Msg.notice({
                title: React.language("app.batch.import.tip"),
                type: "async",
                duration: 0,
                content: React.language("member.async.start.tip")
              })
              file.append('groupid', id)
              $('.btn-status').text(React.language("app.batch.import.tip"));
              FX.Utils.ajaxUpload({
                url: '/dashboard/importbby',
                data: file
              }, function (d) {
                FX.Msg.notice({
                  title: d.msg || d.info,
                  type: "success",
                  duration: 0,
                })
                i._fetchAppList();
              }, null, function (d) {

                if (copyDialog) {
                  copyDialog.close();
                  copyDialog = null;
                }

                d.responseJSON && FX.Msg.notice({
                  title: d.responseJSON.msg,
                  type: "error",
                  duration: 0,
                })
              });
            });
          }
        }
      }
    });
    copyDialog.show();
  }

  openExportAppPane = () => {
    let appsEl = null;
    BsyDialog({
      title: React.language('batch.export.app'),
      subTitle: "<b style='color: #4D609F;font-size: 12px;font-weight: normal;'>" + React.language('batch.export.app.msg') + "</b>",
      height: 575,
      width: 800,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: (ref) => {
        setTimeout(() => {
          appsEl = new window.FX.AppExportPane({
            renderEl: window.$("<div/>").appendTo(ref.element.current.getElementsByClassName("dialog-body")[0]),
            // isStandard: !0,
            // value: {
            //   app: apps
            // },
            onStopEdit: function (e) {
              var label = this.onChangeLabel();
            }
          })
        }, 300)
      },
      onOk: () => {
        appsEl && appsEl._export();
      }
    })
  }

  renderGroup = (item, dockItem) => {
    const { hasUpdate } = this.state;
    return (
      <>
        <div className="allTitle">
          <div className="allTitleCont">
            <div
              className="allTitleName">{this.state.isStandard ? React.language("all.standard.application") : React.language('allapp')}</div>
            {
              // !this.state.isStandard && hasUpdate && <div className="project-update-content">
              //   <div className="update-left">
              //     <i className="icon-bsy-import-export"></i>
              //     <span>{React.language("has.standard.app.update")}</span>
              //   </div>
              //   <div className="update-right">
              //     <div className="go-update-btn" onClick={this.openUpdateStandardAppPane}>
              //       <i className="icon-bsy-go-update"></i>
              //       <span>{React.language("go.update")}</span>
              //     </div>
              //   </div>
              // </div>
            }
            <div className="allTitleRight">
              {
                !this.state.isStandard && (BsyUtils.isCorpOwn() || BsyUtils.isSysManager()) && <div className="import-export-btn" onClick={this.openExportAppPane}>
                  <i className="icon-bsy-reportmenu-7"></i>
                  <span>{React.language('batch.export.app')}</span>
                </div>
              }
              {
                !this.state.isStandard && hasUpdate && <div className="import-export-btn"
                  style={{
                    marginLeft: 23,
                  }}
                  onClick={this.openUpdateStandardAppPane}>
                  <i className="icon-bsy-reportmenu-15"></i>
                  <span>{React.language('update.app')}</span>
                </div>
              }
              {
                (BsyUtils.isCorpOwn() || BsyUtils.isSysManager()) ?
                  <div className="bsy-workspace-app-add">
                    {
                      this.state.isStandard ?
                        <div className="group-box-item-standard-add" onClick={this.openAddStandardPane}>
                          <i className="icon-bsy-add" />
                          <span>{React.language("create")}</span>
                        </div> :
                        <a className="group-box-item-add-blank-app" href={window.rootDirectroy + "/bsymember/appstore"}>
                          <i className="icon-bsy-add" />
                          <span>{React.language('create')}</span>
                        </a>
                    }
                  </div> : ''
              }
            </div>
          </div>
          <div className="allTitleLine"></div>
        </div>
        {
          item.map((data, index) => {
            data.index = index;
            if (BsyUtils.isNormalUser() && data.apps.length === 0) {
              return <></>
            }
            return <div className='bsy-workspace-app_group' id={"appgroup_" + data._id}
              key={data._id + index.toString()}
            >
              {
                this.renderApp(data)
              }
            </div>
          })
        }
        {
          dockItem.map((data, index) => {
            data.index = index;
            if (BsyUtils.isNormalUser() && data.apps.length === 0) {
              return <></>
            }
            return <div className='bsy-workspace-app_group' id={"appgroup_" + data._id}
              key={data._id + index.toString()}
            >
              {
                this.renderApp(data, true)
              }
            </div>
          })
        }
      </>
    )
  }

  changeGroup = (data) => {
    this.setState({
      groupId: data._id
    }, () => {
      this.props.history.push(window.rootDirectroy + (this.state.isStandard ? "/team/standard/group/" : "/team/group/") + data._id)
      setTimeout(() => {
        if (data._id) {
          this.appView.current.scrollTop = document.getElementById("appgroup_" + data._id).offsetTop - 62;
        } else {
          this.appView.current.scrollTop = 0;
        }
      }, 30)
    })
  }

  addGroup = (data) => {
    let that = this;
    BsyAlertTextEdit({
      title: React.language('app.edit.group.create'),
      placeholder: React.language("app.edit.group.placeholder"),
      value: data.name,
      width: 350,
      onOk: (value) => {
        let result = {};
        if (!BsyUtils.checkValidateTitle(value, React.language("receipt.fullName"), result, 64)) {
          return false;
        }
        if (!value) {
          tipAlert({
            type: "warning",
            msg: React.language('app.edit.group.fail2')
          })
          return false;
        }

        React.axios(this.state.isStandard ? '/dashboard/standardapp_group/create' : '/dashboard/app_group/create', {
          groupId: data._id,
          name: value
        }).then(res => {

          let newapp = [...that.state.apps];
          newapp.push({
            _id: res.data._id,
            apps: [],
            name: value,
            appcount: 0
          })
          that.setState({
            apps: newapp
          })
        }).catch(res => {
          console.error(res);
        })
      }
    })
  }

  reGroupName = (data) => {
    const that = this;
    BsyAlertTextEdit({
      title: React.language('rename.group'),
      placeholder: React.language("enter.new.appName"),
      value: data.name,
      width: 350,
      onOk: (name) => {
        let result = {};
        if (!BsyUtils.checkValidateTitle(name, React.language("receipt.fullName"), result, 64)) {
          return false;
        }
        if (!name) {
          tipAlert({
            type: "warning",
            msg: React.language('app.edit.group.fail2')
          })
          return false;
        }

        React.axios(this.state.isStandard ? '/dashboard/standardapp_group/rename' : '/dashboard/app_group/rename', {
          groupId: data._id,
          name: name
        }).then(res => {

          let newapp = [...that.state.apps];
          newapp[data.index].name = name;
          that.setState({
            apps: newapp
          })
        }).catch(res => {
          console.error(res);
        })

      },
      onCancel: () => {

      }
    })
  }

  removeGroup = (data) => {
    const that = this;
    if (data.apps.length > 0) {
      tipAlert({
        type: "warning",
        msg: React.language('app.group.deleted')
      })
      return;
    }

    BsyAlert({
      title: React.language("confirm.appGroup.deleted", {
        name: data.name,
      }),
      msg: '',
      type: "warning",
      text4Ok: React.language("delete"),
      OkType: "red",
      text4Cancel: React.language("cancel"),
      ok: () => {

        React.axios(this.state.isStandard ? '/dashboard/standardapp_group/delete' : '/dashboard/app_group/delete', {
          groupId: data._id
        }).then(res => {

          let newapp = [...that.state.apps];
          newapp.splice(data.index, 1);
          that.setState({
            apps: newapp
          })
        }).catch(res => {
          console.error(res);
        })
        return !0
      }
    })
  }

  moreGroup = (data, e) => {
    let that = this;
    let event = e.currentTarget;
    event.classList.add("hover");
    let menu = [{
      text: React.language('rename.group'),
      colorType: "",
      click: () => {
        event.classList.add("hover");
        BsyAlertTextEdit({
          title: React.language('rename.group'),
          placeholder: React.language("enter.new.appName"),
          value: data.name,
          width: 350,
          onOk: (name) => {
            let result = {};
            if (!BsyUtils.checkValidateTitle(name, React.language("receipt.fullName"), result, 64)) {
              return false;
            }
            if (!name) {
              tipAlert({
                type: "warning",
                msg: React.language('app.edit.group.fail2')
              })
              return false;
            }

            React.axios(this.state.isStandard ? '/dashboard/standardapp_group/rename' : '/dashboard/app_group/rename', {
              groupId: data._id,
              name: name
            }).then(res => {

              let newapp = [...that.state.apps];
              newapp[data.index].name = name;
              that.setState({
                apps: newapp
              })
            }).catch(res => {
              console.error(res);
            })
            event.classList.remove("hover")
          },
          onCancel: () => {
            event.classList.remove("hover");
          }
        })
      }
    }, {
      text: React.language('delete.group'),
      colorType: "red",
      click: () => {
        event.classList.add("hover");
        if (data.apps.length > 0) {
          tipAlert({
            type: "warning",
            msg: React.language('app.group.deleted')
          })
          event.classList.remove("hover");
          return false;
        }

        BsyAlert({
          title: React.language("confirm.appGroup.deleted", {
            name: data.name,
          }),
          msg: '',
          type: "warning",
          text4Ok: React.language("delete"),
          OkType: "red",
          text4Cancel: React.language("cancel"),
          ok: () => {

            React.axios(this.state.isStandard ? '/dashboard/standardapp_group/delete' : '/dashboard/app_group/delete', {
              groupId: data._id
            }).then(res => {

              let newapp = [...that.state.apps];
              newapp.splice(data.index, 1);
              that.setState({
                apps: newapp
              })
              event.classList.remove("hover");
            }).catch(res => {
              console.error(res);
              event.classList.remove("hover");
            })
            return !0
          }
        })

      }
    }]

    BsyAlertMenu({
      item: menu,
      width: 140,
      target: e.target,
      onClose: () => {
        event.classList.remove("hover");
      }
    })

    // this.setState({
    //     groupId: data._id
    // })
  }

  _menuSort = () => {
    let $ = window.$;
    let FX = window.FX;
    let _this = this;
    if (!FX.STATIC.user_corps.isSysManager)
      return;
    if ($(this.myapp.current)) {
      let d;
      $(this.myapp.current).sortable({
        scroll: !0,
        itemSelector: "div.list",
        onDragStart: function (t, e, a, n) {
          t.addClass("entry-sort");
          let s = t.offset()
            , o = e.rootGroup.pointer;
          d = o.top - s.top
          a(t)
        },
        onDrag: function (t, e, a, n) {
          let s = t.offset()
          e.left = s.left;
          e.top -= d;
          a(t, e);
        },
        onDrop: function (a, b, c, d) {
          a.removeClass("entry-sort");
          c(a);
          _this._groupSort();
        },
        getScrollEl: function (b, c, d, e) {
          return c.options.scroll ? $(_this.myapp.current) : null
        }
      });
    }
  }

  _groupSort = () => {
    let $ = window.$;
    let FX = window.FX;
    let _this = this;
    let sort = [];
    $(_this.myapp.current).find(".menu-item.list").map((a1, b1) => {
      const id = b1.getAttribute("id");
      if (id) {
        sort.push(id);
      }
    })

    FX.Utils.ajax({
      url: _this.state.isStandard ? "/dashboard/standardapp_group/updatesort" : "/dashboard/app_group/updatesort",
      data: {
        sort: sort
      }
    }, function (d) {
      if (d.code === 0 || d.code === 200) {
        window.app_group = [];
        FX.Utils.forEach(sort, function (a1, b1) {
          FX.Utils.forEach(_this.state.apps, function (a2, b2) {
            b1 === b2._id && window.app_group.push(b2)
          })
        })
        _this.setState({
          apps: window.app_group
        })
      } else {
        tipAlert({
          type: "warning",
          msg: React.language(d.msg) || React.language("app.edit.group.fail1")
        })
      }
    }, function (a, b) {
      let c = a.responseJSON || {};
      tipAlert({
        type: "error",
        msg: React.language(c.msg) || React.language("app.edit.group.fail1")
      })
    }, function () {

    })
  }


  AllGroup = () => {
    this.setState({
      groupId: ''
    }, () => {
      this.props.history.push(window.rootDirectroy + (this.state.isStandard ? "/team/standard/apps" : "/team/apps"))
      setTimeout(() => {
        this.appView.current.scrollTop = 0;
      })
    })
  }

  AllDockApp = () => {
    this.setState({
      groupId: 'dockApp'
    }, () => {
      this.props.history.push(window.rootDirectroy + (this.state.isStandard ? "/team/standard/dockApp" : "/team/dockApp"))
      setTimeout(() => {
        this.appView.current.scrollTop = 0;
      })
    })
  }

  render() {
    const { apps, groupId, dockItem } = this.state;
    setPageTitle(this.props.title || React.language('dashboard'));
    return (

      <div className={`bsy-workspace-pane ${this.state.isStandard ? "standard" : ""}`}>
        <div className='bsy-workspace-view'>
          <div className='bsy-workspace-content'>
            <div className='bsy-workspace-content-view'>
              <div className="bsy-workspace-menu">
                <div className="bsy-workspace-menu-myapp">
                  <div className="menu-item no-cursor" >
                    <span
                    >{this.state.isStandard ? <> <span  >{React.language("all.standard.application")}</span></> : React.language('app.group')}</span>
                    {(BsyUtils.isCorpOwn() || BsyUtils.isSysManager()) && <span className="op">
                      <i style={{ fontWeight: "bold", fontSize: "16px" }} className="icon-bsy-add" onClick={this.addGroup} />
                    </span>}
                  </div>

                  <div className={"menu-item allapp " + (!groupId ? 'select' : '')} onClick={this.AllGroup}>
                    <i className="icon-all-app" />
                    <span>{this.state.isStandard ? React.language("all.standard.application") : React.language('allapp')}</span>
                  </div>
                </div>
                <ul className="bsy-workspace-menu-myapp-list" ref={this.myapp}>
                  {
                    apps.map((data, index) => {
                      if (BsyUtils.isNormalUser() && data.apps.length === 0) {
                        return <></>
                      }
                      return <div
                        className={"menu-item list " + (groupId === data._id ? 'select' : '')}
                        id={data._id}
                        key={data._id + index.toString()}
                        onClick={e => {
                          this.changeGroup(data);
                          e.stopPropagation()
                        }}
                      >
                        <span className="name" title={data.name}>{data.name}</span>
                        {
                          (BsyUtils.isCorpOwn() || BsyUtils.isSysManager()) ?
                            <span className="op"
                              onClick={e => {
                                this.moreGroup(data, e);
                                e.stopPropagation()
                              }}
                            ><i className="icon-bsy-icongengduo1" />
                            </span> : ''
                        }

                      </div>
                    })
                  }
                  {/*<div className="menu-item add-group"*/}
                  {/*    onClick={this.addGroup}*/}
                  {/*>*/}
                  {/*    <i className="icon-bsy-add"/>*/}
                  {/*    <span>{React.language('app.creategroup')}</span>*/}
                  {/*</div>*/}
                </ul>
                {dockItem.length > 0 && <>
                  <div className="bsy-workspace-menu-myapp" style={{ marginTop: 14 }}>
                    <div className="menu-item no-cursor">
                      <span>{React.language('app.dock')}</span>
                    </div>
                  </div>
                  <ul className="bsy-workspace-menu-myapp-list" ref={this.mydockapp}>
                    {
                      dockItem.map((data, index) => {
                        if (BsyUtils.isNormalUser() && data.apps.length === 0) {
                          return <></>
                        }
                        return <div
                          className={"menu-item list " + (groupId === data._id ? 'select' : '')}
                          id={data._id}
                          key={data._id + index.toString()}
                          onClick={e => {
                            this.changeGroup(data);
                            e.stopPropagation()
                          }}
                        >
                          <span className="name" title={data.name}>{data.name}</span>
                          {/* {
                                                            (BsyUtils.isCorpOwn() || BsyUtils.isSysManager()) ? <span className="op"
                                                                onClick={e => { this.moreGroup(data, e); e.stopPropagation() }}
                                                            ><i className="icon-bsy-icongengduo1" />
                                                            </span> : ''
                                                        } */}

                        </div>
                      })
                    }
                    {/*<div className="menu-item add-group"*/}
                    {/*    onClick={this.addGroup}*/}
                    {/*>*/}
                    {/*    <i className="icon-bsy-add"/>*/}
                    {/*    <span>{React.language('app.creategroup')}</span>*/}
                    {/*</div>*/}
                  </ul>
                </>}

              </div>
              <div className="bsy-workspace-appCont" ref={this.appView}>
                <div className="bsy-workspace-appView">
                  {
                    this.renderGroup(apps, dockItem)
                  }

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    )
  }
}

export default withRouter(BsyAppPane)